module.exports = __webpack_public_path__ + "img/sponsor-carousel-bishop.34be0f07.jpg";